import {
  Button,
  Card,
  LoadingButton,
  Typography,
} from '@oresundsbron/bridge-ui';
import { Close } from '@oresundsbron/icons';
import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'next-i18next';
import { FC, useState } from 'react';

type ConfirmRefundModalProps = {
  onConfirm: () => void;
  onClose: () => void;
};

export const ConfirmRefundModal: FC<ConfirmRefundModalProps> = ({
  onConfirm,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['onlineTicket', 'common'], {
    nsMode: 'fallback',
  });

  return (
    <Dialog.Root defaultOpen onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-20 bg-black/75" />
        <Card.Root
          as={Dialog.Content}
          className="fixed inset-1/2 z-20 h-min w-[90vw] max-w-xl translate-x-[-50%]  translate-y-[-50%]"
        >
          <Card.Header className="relative bg-primary-950">
            <Typography as="h2" intent="title" color="white">
              {t('refund.confirm.title')}
            </Typography>
            <Dialog.Close asChild>
              <Button
                intent="text"
                aria-label={t('action.close')}
                className="absolute right-6 top-4"
                startIcon={<Close />}
                color="white"
                iconSize="lg"
                disabled={loading}
              />
            </Dialog.Close>
          </Card.Header>
          <Card.Content>
            <Typography>{t('refund.confirm.description')}</Typography>
          </Card.Content>
          <Card.Footer className="flex justify-end gap-4">
            <Dialog.Close asChild>
              <Button intent="text" disabled={loading}>
                {t('action.cancel')}
              </Button>
            </Dialog.Close>
            <LoadingButton
              onClick={() => {
                setLoading(true);
                onConfirm();
              }}
              loadingLabel={t('action.loading')}
              isLoading={loading}
            >
              {t('action.continue')}
            </LoadingButton>
          </Card.Footer>
        </Card.Root>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
